import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { ThemeProvider } from '@/design/ThemeProvider';
import { router } from '@/app/router';
import { useProfileStore } from '@/modules/profile/profileStore';
import '@/design/tokens.css';

const container = document.getElementById('root');
if (container === null) throw new Error('Root element is missing from index.html');

/**
 * Open shared storage before the first render.
 *
 * Deliberately not awaited. Storage is not needed to draw the shell, and
 * blocking the first paint on a database handshake would trade a visible
 * delay for nothing. Screens read storage through the store and re-render
 * when it arrives.
 */
void useProfileStore.getState().initialise();

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </StrictMode>,
);
